import { createSlice } from '@reduxjs/toolkit';

const directiosApiRoutePointRawSlice = createSlice({
  name: 'directiosApiRoutePointRaw',
  initialState: {
    // Raw Directions API response stored exactly as received from Mapbox.
    payload: null
  },
  reducers: {
    setDirectiosApiRoutePointRaw(state, action) {
      state.payload = action.payload ?? null;
    },
    resetDirectiosApiRoutePointRaw(state) {
      state.payload = null;
    }
  }
});

export const { setDirectiosApiRoutePointRaw, resetDirectiosApiRoutePointRaw } =
  directiosApiRoutePointRawSlice.actions;
export default directiosApiRoutePointRawSlice.reducer;
